import { motion } from "framer-motion";
import SignalGauge from "@/components/SignalGauge";

const signals = [
  {
    label: "Capacity Load",
    value: 62,
    status: "amber",
    hint: "How much of the household's sustainable capacity is committed right now.",
  },
  {
    label: "Compression Index",
    value: 71,
    status: "amber",
    hint: "How tightly commitments are packed against buffer, transitions, and rest.",
  },
  {
    label: "Recovery Margin",
    value: 34,
    status: "red",
    hint: "The protected time remaining before capacity begins to erode.",
  },
];

export default function Signals() {
  return (
    <section
      id="signals"
      data-testid="signals-section"
      className="relative border-t border-rule bg-deep/40 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-teal">
            03 — The three readings
          </p>
          <h2 className="mt-6 font-display text-4xl leading-[1.05] text-ink md:text-5xl">
            Three numbers that tell the truth.
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-mist">
            Not a to-do count. Not a streak. Three honest measurements about
            what your household can hold — and what it needs to protect.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {signals.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.7,
                delay: i * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <SignalGauge
                label={s.label}
                value={s.value}
                status={s.status}
                hint={s.hint}
                testId={`signal-${s.label.toLowerCase().replace(/ /g, "-")}`}
              />
            </motion.div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-3 gap-6">
          {[
            ["Green", "signalGreen", "Stable · hold pattern"],
            ["Amber", "signalAmber", "Compressed · mitigate"],
            ["Red", "signalRed", "Overloaded · protect recovery"],
          ].map(([label, color, desc]) => (
            <div
              key={label}
              className="flex items-center gap-3 border-t border-rule pt-4"
            >
              <span
                className={`h-2 w-2 rounded-full bg-${color}`}
                style={{
                  backgroundColor:
                    color === "signalGreen"
                      ? "#4E8B7C"
                      : color === "signalAmber"
                        ? "#D98A44"
                        : "#B75555",
                }}
              />
              <div className="min-w-0">
                <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-mist">
                  {label}
                </div>
                <div className="mt-0.5 truncate text-xs text-ink md:text-sm">
                  {desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
